<template>
	<div class="shangcheng-box">
		<div class="type-wrap">
			<span class="type-title">配件商城</span>
			<span class="tag">热卖HOT</span>
			<div class="brand-wrap">
				<div
					class="brand-item"
					v-for="(item, index) in brandList"
					:key="index"
					@click="handleIsLogin(item)"
				>
					<el-avatar
						:size="24"
						shape="square"
						:src="item.Url"
						fit="contain"
					></el-avatar
					><span class="brand-name">{{ item.Name }}</span>
				</div>
			</div>
			<div @click="handleToList" class="more-wrap">
				查看更多<span class="el-icon-arrow-right" />
			</div>
		</div>
		<div v-if="!this.token" class="content-wrap unlogined-wrap">
			<div class="img-wrap"></div>
			<div
				class="detail-wrap"
				v-for="(item, index) in list"
				:key="index"
				@click="handleLogin"
			>
				<div class="detail-content-wrap">
					<div class="parts-vin-wrap">
						<span class="parts-name">{{ item.AutoPartsName }}</span>
						<!-- <span class="vin">{{ item.VIN }}</span> -->
					</div>
					<div class="vehicle-wrap">
						<span class="vehicle-name">{{ item.VehicleName }}</span>
					</div>
				</div>

				<div
					class="detail-img-wrap"
					:style="{'background-image': `url(${item.AutoPartsPic1})`}"
				>
					<!-- <el-image
            style="width: 100%; height: 100%"
            :src="item.AutoPartsPic1"
            fit="cover"
          ></el-image> -->
        </div>
        <div class="detail-content-wrap">
          <div class="tag-wrap">
            <span class="tag">包邮</span>
          </div>
          <div class="tag-wrap">
            <span
              class="tag"
              v-if="item.MctName == 'XSZ' || item.MctName == '苏广科技'"
              >苏广科技</span
            >
            <span style="background-color: #00baad" class="tag" v-else
              >无锡再生资源</span
            >
          </div>
          <div class="tag-wrap">
            <span class="tag">100%实物拍摄</span>
          </div>
          <div class="price-wrap">{{ item.Price }}</div>
        </div>
      </div>
    </div>
    <div v-else-if="list" @click="handleClick($event)">
      <vue-seamless-scroll
        style="overflow: hidden"
        :data="listData"
        :class-option="classOption"
      >
        <div class="logined-content-box" style="width: 100%">
          <div
            class="logined-item"
            v-for="(item, index) in list"
            :key="index"
            :data-obj="JSON.stringify(item)"
          >
            <div style="height: 318px; font-size: 0">
              <img
                v-if="item.AutoPartsPic1"
                style="height: 100%; width: 100%; object-fit: cover"
                :src="item.AutoPartsPic1"
              />
              <img
              style="height: 100%; width: 100%; object-fit: cover"
              v-else src="../../../assets/Nofigure.png" alt="">
              <!-- <el-image
              style="height: 100%; width: 100%"
              src="https://img.js.design/assets/img/63461c429795a78eae4b72b9.png#bc920b7bb4d729743558b7558c6d08cf"
              fit="cover"
            /> -->
						</div>

						<div class="bagPicBox" v-if="item.ActivePrice != item.Price">
							<img :src="activityByCenter" alt="" />
						</div>
						<div class="logined-content-wrap">
							<div class="price-box" v-if="item.ActivePrice == item.Price">
								<span>￥</span><span>{{ item.Price }}</span>
							</div>
							<div class="price-box" v-if="item.ActivePrice != item.Price">
								<span>￥</span><span>{{ item.ActivePrice }}</span>
								<span class="lineText1">￥</span
								><span class="lineText">{{ item.Price }}</span>
							</div>
							<div>
								<span class="part-name">{{ item.AutoPartsName }}</span>
								<span class="level tag" :style="item.QLevel | getLevelColor">{{
									item.QLevel
								}}</span>
							</div>
							<div style="margin-top: 6px">
								<span
									class="shop-name tag"
									:style="item.MctCode | getShopColor"
									@click.stop="handelGoShop(item)"
									>{{ item.MctName }}
									<span class="el-icon-arrow-right" />
								</span>
								<span class="PhysicalPic" v-if="item.AutoPartsPic1"
									>100%实物图</span
								>
							</div>
							<div class="flex align-center" style="gird-columns-gap: 5px">
								<div class="vehicle-name single-ellipse flex-sub">
									{{ item.VehicleName }}
								</div>

								<div class="cart-wrap" @click.stop="handelSaveMyCart(item)">
									<img
										style="width: 60%; height: 60%"
										src="@/assets/shopCart.png"
										alt=""
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</vue-seamless-scroll>
		</div>
	</div>
</template>
<script>
import vueSeamlessScroll from "vue-seamless-scroll"
import {SaveMyCart, TopBrand} from "@/api/merchant/dashboard"
import {activityByCenter} from "@/utils/activityImg.js"
import {mapGetters} from "vuex"
export default {
	data() {
		return {
			activityByCenter: activityByCenter,
			listData: [1, 2, 3, 4, 5, 6, 7],
			classOption: {
				limitMoveNum: 2,
				direction: 2
			},
			brandList: [],
			color: "red"
		}
	},
	inject: ["getShopList"],
	created() {
		TopBrand().then((res) => {
			this.brandList = res
		})
	},
	computed: {
		list() {
			console.log(this.getShopList())

			return this.getShopList()
		},
		...mapGetters(["token"])
	},
	components: {
		vueSeamlessScroll
	},
	methods: {
		handelGoShop(e) {
			console.log(e, 99999)
			this.$router.push({
				path: "/shop-list",
				query: {MctCode: e.MctCode}
			})
			// this.$router.push("/shop-list")
		},
		handleSearch(item) {
			const {Name} = item
			// this.$router.push({ name: "parts-list", params: { searchKey: Name } });
			this.$router.push({
				name: "parts-list",
				params: {
					topBrand: item
				}
			})
		},
		handelSaveMyCart(item) {
			// SaveMyCart({ Data: item }).then((res) => {
			//   this.$message({
			//     type: "success",
			//     message: "添加成功",
			//   });
			// });
			this.$store.dispatch("merchant/addToCart", {Data: item}).then((res) => {
				this.$message({
					type: "success",
					message: "添加成功"
				})
			})
		},
		handleToList() {
			if (!this.token) {
				this.handleLogin()
				// return true;
			} else {
				this.$router.push("/parts-list")
			}
		},
		handleClick($event) {
			let obj = null
			let objStr = $event.target.dataset.obj
			if (objStr) {
				obj = JSON.parse($event.target.dataset.obj)
			} else {
				let parentNode = this.getParents($event.target, "logined-item")
				obj = JSON.parse(parentNode.dataset.obj)
			}
			this.handleToDetail(obj)
		},
		handleToDetail(item) {
			// const { MctCode, BarCode, WhId, WhbId } = item;
			// this.$router.push({
			//   path: "/parts-detail",
			//   query: { MctCode, BarCode, WhId, WhbId },
			// });
			this.$router.push({
				path: `/parts-detail/?MctCode=${item.MctCode}&BarCode=${
					item.BarCode
				}&WhId=${item.WhId}&WhbId=${item.WhbId}&list=${true}`
				// 传递的参数集合
			})
			// this.$emit('nav',item)
		},
		getParents(element, className) {
			let ParentElement = null
			function getpNode(element, className) {
				//创建父级节点的类数组
				let pClassList = element.parentNode.getAttribute("class")
				let pNode = element.parentNode
				if (!pClassList) {
					getpNode(pNode, className)
				} else if (pClassList && pClassList.indexOf(className) < 0) {
					getpNode(pNode, className)
				} else if (pClassList && pClassList.indexOf(className) > -1) {
					ParentElement = pNode
				}
			}
			getpNode(element, className)
			return ParentElement
		},
		handleLogin() {
			this.$emit("login", true)
		},
		handleIsLogin(item) {
			if (!this.token) {
				this.handleLogin()
				// return true;
			} else {
				this.handleSearch(item)
			}
		}
	}
}
</script>
<style lang="scss">
.brand-item {
	.el-avatar {
		background-color: transparent;
	}
}
</style>
<style lang="scss" scoped>
.cart-wrap {
	// position: absolute;
	cursor: pointer;
	position: relative;
	top: -6px;
	width: 40px;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(254, 118, 72, 1);
	border-radius: 50%;
}
.shangcheng-box {
	margin-bottom: 15px;
	.type-wrap {
		position: relative;
		margin-bottom: 15px;
		padding: 7px 20px 7px 27px;
		border-radius: 10px;
		background: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		.type-title {
			font-size: 26px;
			font-weight: 500;

			color: rgba(29, 32, 137, 1);
		}
		.tag {
			position: relative;
			// padding: 15px 12px 15px 7px;
			padding-left: 7px;
			padding-right: 12px;
			padding-top: 5px;
			padding-bottom: 5px;
			background: linear-gradient(
				90deg,
				rgba(37, 117, 252, 1) 0%,
				rgba(106, 17, 203, 1) 100%
			);
			font-size: 16px;
			font-weight: 400;
			color: rgba(255, 255, 255, 1);
			border-radius: 6px;
			margin-left: 18px;
			&::before {
				position: absolute;
				content: "";
				border-width: 6px;
				border-style: solid;
				border-color: transparent rgba(37, 117, 252, 1) transparent transparent;
				left: -12px;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		.brand-wrap {
			display: flex;
			margin-left: 40px;
			.brand-item {
				cursor: pointer;
				& + .brand-item {
					margin-left: 20px;
				}
				background-color: transparent;
				display: flex;
				align-items: center;
				.brand-name {
					font-size: 10px;
					font-weight: 400;
					color: rgba(56, 56, 56, 1);
					margin-left: 5px;
				}
			}
		}
		.more-wrap {
			cursor: pointer;
			position: absolute;
			font-size: 16px;
			font-weight: 400;
			color: rgba(56, 56, 56, 1);
			right: 20px;
		}
	}
	.content-wrap {
		display: grid;
		grid-template-columns: 310px auto auto auto;
		grid-template-rows: repeat(2, 275px);
		grid-gap: 10px;
		&.unlogined-wrap {
			height: 560px;
			overflow: hidden;
			.detail-img-wrap {
				background-size: auto;
				background-repeat: no-repeat;
				background-position: center;
			}
		}
		.img-wrap {
			grid-row: 1/3;
			border-radius: 10px;
			background-image: url("~@/assets/dash_common/baokuan.png");
			background-position: center center;
			background-repeat: no-repeat;
			background-size: cover;
		}
		.detail-wrap {
			position: relative;
			cursor: pointer;
			background-color: white;
			border-radius: 10px;
			padding: 32px 18px 13px;

			.detail-img-wrap {
				width: 208px;
				height: 196px;
				float: right;
				margin-top: -50px;
			}
			.detail-content-wrap {
				color: rgba(56, 56, 56, 1);
				position: relative;
				.parts-vin-wrap {
					.parts-name {
						font-size: 18px;
						font-weight: 600;
					}
					.vin {
						margin-left: 5px;
						font-size: 12px;
						font-weight: 550;
					}
				}
				.vehicle-wrap {
					margin-bottom: 11px;
					width: 180px;
					.vehicle-name {
						font-size: 12px;
						font-weight: 400;
						color: rgba(56, 56, 56, 1);
					}
				}

				.tag-wrap {
					.tag {
						padding: 3px 13px;
						border-radius: 30px;
						color: white;
					}
					&:nth-of-type(1) .tag {
						background-color: rgba(255, 26, 26, 1);
					}
					&:nth-of-type(2) .tag {
						background-color: rgba(29, 32, 137, 1);
					}
					&:nth-of-type(3) .tag {
						background-color: rgba(176, 177, 177, 1);
					}
					& + .tag-wrap {
						margin-top: 12px;
					}
				}
				// .tag-wrap + .tag-wrap {
				//   margin-top: 8px;
				// }
				.price-wrap {
					margin-top: 40px;
					position: relative;
					font-size: 24px;
					font-weight: 700;
					color: rgba(254, 118, 72, 1);
					&::before {
						content: "￥";
					}
				}
			}
		}
	}
	.logined-content-box {
		display: flex;
		// display: grid;
		// grid-template-columns: repeat(auto-fill, 344px);
		// grid-column-gap: 18px;
		// grid-template-rows: auto;
		.logined-item {
			position: relative;
			cursor: pointer;
			width: 344px;
			margin-right: 18px;
			border-radius: 10px;
			background-color: white;
			overflow: hidden;
			.bagPicBox {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 318px;
				// top: 12px;
				// left: 12px;

				// width: 100%;
				// height: 318px;
				z-index: 12;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.logined-content-wrap {
				padding: 7px 13px 12px;
				.price-box {
					font-size: 24px;
					font-weight: 700;
					color: rgba(254, 118, 72, 1);
					.lineText1 {
						margin-left: 5px;
						font-size: 10px;
						font-weight: 400;
						color: grey;
						text-decoration-line: line-through;
					}
					.lineText {
						font-size: 10px;
						font-weight: 400;
						color: grey;
						text-decoration-line: line-through;
					}
				}
				.tag {
					padding: 1px 10px;
					opacity: 1;
					border-radius: 30px;
					font-size: 12px;
					line-height: 12px;
					font-weight: 400;
					color: rgba(255, 255, 255, 1);
					margin-right: 5px;
				}
				.level {
					background: rgba(254, 118, 72, 1);
				}
				.shop-name {
					background: rgba(29, 32, 137, 1);
				}
				.PhysicalPic {
					padding: 0 10px;
					height: 18px;
					line-height: 18px;
					text-align: center;
					background-color: #b0b1b1;
					color: #fff;
					border-radius: 50px;
				}
				.part-name {
					font-size: 16px;
					font-weight: 600;
					color: rgba(56, 56, 56, 1);
					margin-right: 5px;
				}
				.vehicle-name {
					margin-top: 6px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					font-size: 14px;
					font-weight: 400;
					color: rgba(56, 56, 56, 1);
				}
			}
		}
	}
}
</style>
